
import { TrashIcon, ReplyIcon } from "@vue-hero-icons/outline";

import dayjs from "dayjs";
import { CONTANTS } from "~/constants";
const monthReports = () => import("~/static/jsons/MonthReports.json");
const CorePageController = () =>
  import(
    "~~/_core/collections/components/elements/pageController/PageController.vue"
  );
const CoreDateRange = () =>
  import("~~/_core/collections/components/elements/dateTime/DateRange.vue");

export default {
  layout: "default",

  fetchOnServer: false,

  components: { TrashIcon, ReplyIcon, CoreDateRange, CorePageController },

  data() {
    return {
      TYPES: [
        { id: "income", label: "Thu nhập" },
        { id: "cost", label: "Chi phí" },
        { id: "personal", label: "Chi phí cá nhân" },
        { id: "tax", label: "Chi phí Thuế & hành chính cá nhân" },
        { id: "family", label: "Chi phí Gia đình & con cái" },
        { id: "invest", label: "Chi phí Đầu tư & thuê người" },
      ],
      data: null,
      deleteId: null,
      detail: null,
      currentPage: 1,
      history: null,
      categories: [],
      model: {
        category: "",
        type: "",
        range: {
          start: null,
          end: null,
        },
      },
    };
  },

  async fetch() {
    // await this.fetchDetailApi()
    // await this.fetchApi()
    await this.fetchHistory();
  },

  mounted() {
    monthReports().then((data) => (this.categories = data));
  },

  head() {
    return {
      title: this.metaTitle,
      meta: [
        { hid: "title", name: "title", content: this.metaTitle },
        { hid: "description", name: "description", content: this.metaDesc },
        { hid: "image", name: "image", content: this.metaImage },
        { hid: "og:url", property: "og:url", content: this.routePath },
        { hid: "og:title", property: "og:title", content: this.metaTitle },
        { hid: "og:image", property: "og:image", content: this.metaImage },
        {
          hid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: this.metaImage,
        },
        {
          hid: "og:image:secure",
          property: "og:image:secure",
          content: this.metaImage,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.metaTitle,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.metaDesc,
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.metaTitle,
        },
        {
          hid: "twitter:image:alt",
          name: "twitter:image:alt",
          content: this.metaTitle,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.metaDesc,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: this.metaImage,
        },
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `${this.canonical}`,
        },
      ],
      script: [
        {
          innerHTML: `{
            "@context": "http://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "${this.routePath}"
            },
            "headline": "${this.metaTitle}",
            "image": "${this.metaImage}",
            "datePublished": "${this.datePublished}",
            "dateModified": "${this.datePublished}",
            "author": {
              "@type": "Person",
              "name": "${this.$$siteMeta}",
              "url": "${this.routePath}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "${this.$$siteMeta}",
              "logo": {
                "@type": "ImageObject",
                "url": "${this.metaImage}"
              }
            }
          }`,
          type: "application/ld+json",
        },
      ],
      __dangerouslyDisableSanitizers: ["script"],
    };
  },

  computed: {
    id() {
      return this.$nuxt.context.route.params.slug;
    },

    metaTitle() {
      return `${this.$t("meta.invoice.title_history_trade")} | ${
        this.$$siteShortMeta
      }`;
    },

    metaDesc() {
      return `${this.$t("meta.invoice.title_history_trade")} | ${
        this.$$siteShortMeta
      }`;
    },

    defaultMetaImage() {
      return `${this.$config.protocol}://${this.$config.baseHost}/images/metacanhanf.jpeg`;
    },

    metaImage() {
      return this.defaultMetaImage;
    },

    createDate() {
      return this.detail?.create_date;
    },

    datePublished() {
      if (this.createDate) {
        return new Date(this.createDate).toISOString();
      }
      return new Date().toISOString();
    },

    routePath() {
      return `http://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    canonical() {
      return `https://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    detailName() {
      return this.detail?.name;
    },

    detailAmount() {
      return this.detail?.amount;
    },

    historyResults() {
      return this.history?.results;
    },

    pageLength() {
      if (!this.history) {
        return 0;
      }

      let numberOfPage = Math.floor(
        this.history.total / this.history.page_size
      );
      if (numberOfPage * this.history.page_size < this.history.total) {
        numberOfPage += 1;
      }

      return numberOfPage;
    },
  },

  methods: {
    async onSearch() {
      const category = this.model.category;
      const range = this.model.range;
      let params = null;

      if (range.start && range.end) {
        const dateRange = {
          start_date: dayjs(range.start).format("YYYY-MM-DD"),
          end_date: dayjs(range.end).format("YYYY-MM-DD"),
          year: null,
          month: null,
        };

        params = Object.assign({}, params, dateRange);
      }

      if (category) {
        params = Object.assign({}, params, {
          search: category,
          year: null,
          month: null,
        });
      }

      if (params) {
        await this.fetchHistory(1, params);
      }
    },

    async fetchApi() {
      if (!this.id) {
        return;
      }

      const { data } = await this.$axios.request({
        url: "/api/person/report/",
        method: "get",
        params: {
          parent: this.id,
        },
      });

      this.data = data?.results;
    },

    async goToPage(index) {
      this.currentPage = index;
      await this.fetchHistory(this.currentPage);
      window.scrollTo(0, 0);
    },

    async fetchHistory(page = 1, params) {
      const date = dayjs();
      const month = date.month() + 1;
      const year = date.year();

      let apiParams = {
        page_size: 10,
        page,
        month,
        year,
        sub: true,
      };

      if (params) {
        apiParams = { ...apiParams, ...params };
      }

      const { data } = await this.$axios.request({
        url: "/api/person/report/",
        method: "get",
        params: apiParams,
      });

      this.history = data;
    },

    async fetchDetailApi() {
      if (!this.id) {
        return;
      }

      const { data } = await this.$axios.request({
        url: `/api/person/report/${this.id}/`,
        method: "get",
      });

      this.detail = data;
    },

    async deleteTransaction(deleteId) {
      const message = this.$t("common.notify_delete");
      const confirm = await this.$vmodal.confirm({ message });
      if (!confirm) {
        return;
      }

      if (!deleteId) {
        return;
      }

      const { data } = await this.$axios.request({
        url: `/api/person/report/${deleteId}/`,
        method: "delete",
      });

      if (data) {
        // await this.fetchApi()
        this.deleteId = deleteId;
        this.$store.commit("temp/PUT", { reloadReport: true });
        this.$toast.open({ message: this.$t("common.update_success") });
      }
    },

    getFormatAmount(item) {
      if (!item) {
        return "";
      }

      if (item.type == "income") {
        return `+ ${this.$currency(item.amount)}`;
      } else if (item.type == "cost") {
        return `- ${this.$currency(item.amount)}`;
      }

      return "";
    },

    getClass(item) {
      if (!item) {
        return "";
      }

      const today = dayjs();

      if (dayjs(item.create_date).isSame(today, "days")) {
        return "today";
      }

      return "";
    },

    getCategoryName(name) {
      if (!name) {
        return "";
      }

      const newName = name
        .replace("Sub: chi phí từ ", "")
        .replace("Sub: thu nhập từ ", "")
        .replace("Sub Tiền mặt: ", "");

      return `${newName}`;
    },
  },
};
